var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ucar-val",class:{'disabled': _vm.disabled}},[_c('div',{staticClass:"ucar-val-block",on:{"click":_vm.clickHandler}},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }